<template>
  <div class="mb-3">
    <div class="d-inline-block">
      <i
        class="fa fa-lg mt-4 btn-merge"
        :class="{'fa-expand': merge, 'fa-compress': !merge}"
        @click="onSetMerge"
        ></i>
    </div>
    <div class="d-inline-block ml-4">
      <p class="animated" v-if="merge">{{`You have selected ${tabs.length} ${name}(s).`}}</p>
      <ul v-if="!merge" class="nav nav-tabs card-header-tabs" role="tablist">
        <li
          v-for="tab in tabs"
          role="presentation"
          :key="tab.value">
          <a
            class="nav-link"
            :class="{'active': tab.value == activeTab}"
            href="#"
            role="tab"
            @click="onSelectTab(tab.value)"
            data-toggle="tab">{{ tab.text }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'base-tab',
  props: {
    name: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      default: [],
      required: true,
    },
    activeTab: {
      type: Number,
      default: 1,
    },
    merge: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.tabs.length > 0) {
      const tabValues = this.tabs.map(v => v.value);
      if (tabValues.indexOf(this.activeTab) === -1) {
        this.onSelectTab(tabValues[0]);
      }
    }
  },
  computed: {
    hasMerge() {
      return this.merge;
    },
  },
  methods: {
    onSelectTab(idx) {
      this.$emit('tab-change', parseInt(idx, 10));
    },
    onSetMerge() {
      this.$emit('tab-merge', !this.hasMerge);
    },
  },
};
</script>
<style>
.btn-merge {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BaseTab.vue